import { render, staticRenderFns } from "./SourcesForm.vue?vue&type=template&id=07d85fce&scoped=true"
import script from "./SourcesForm.vue?vue&type=script&lang=js"
export * from "./SourcesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d85fce",
  null
  
)

export default component.exports